webpackJsonp([1],Array(33).concat([
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(81)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(108),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Game__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Game___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Game__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Settings__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Highscore__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Highscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Highscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Help__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Help___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Help__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Changelog__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Changelog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Changelog__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'start',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Start___default.a
  }, {
    path: '/game',
    name: 'game',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Game___default.a
  }, {
    path: '/settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Settings___default.a
  }, {
    path: '/highscore',
    name: 'highscore',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Highscore___default.a
  }, {
    path: '/help',
    name: 'help',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Help___default.a
  }, {
    path: '/changelog',
    name: 'changelog',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Changelog___default.a
  }]
}));

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(83)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(110),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ComboGame = function () {
  function ComboGame(level, columns, tileColor) {
    _classCallCheck(this, ComboGame);

    this.tileColor = tileColor;
    this.level = level;
    this.columns = columns;
  }

  _createClass(ComboGame, [{
    key: "setTileColor",
    value: function setTileColor(tileColor) {
      this.tileColor = tileColor;
    }
  }, {
    key: "randomizeHealth",
    value: function randomizeHealth() {
      return Math.floor(Math.random() * (10 * ((10 + this.level) / 15))) + 1;
    }
  }, {
    key: "randomizeMultiplier",
    value: function randomizeMultiplier(health, force) {
      // eslint-disable-line
      var random = Math.floor(Math.random() * 100) + 1;
      if (health <= 3) return 1;
      if (random === 50) return 2;
      if (random === 99) return 3;
      if (force) return 2;
      return 1;
    }
  }, {
    key: "setAtleastOneMultiplier",
    value: function setAtleastOneMultiplier(tiles, level) {
      var _this = this;

      var multipliers = Math.ceil(level / 10);

      var enoughMultipliers = tiles.filter(function (x) {
        return x.multiplier > 1;
      }).length >= multipliers;
      if (!enoughMultipliers) {
        var _loop = function _loop(i) {
          var multiTiles = tiles.filter(function (x) {
            return x.health > 3 && x.multiplier === 1;
          });
          var random = Math.floor(Math.random() * (multiTiles.length - 1 + 1));
          var tile = multiTiles[random];
          var selectedTile = tiles.find(function (x) {
            return x.id === tile.id;
          });

          selectedTile.multiplier = _this.randomizeMultiplier(tile.health, true);
        };

        for (var i = 0; i < multipliers; i += 1) {
          _loop(i);
        }
      }

      if (level % 7 === 0) {
        var sortedTiles = tiles.concat().sort(function (a, b) {
          return b.health - a.health;
        });
        var powerupTile = tiles.find(function (x) {
          return x.id === sortedTiles[0].id;
        });
        powerupTile.multiplier = -1;
      }

      return tiles;
    }
  }, {
    key: "newGame",
    value: function newGame() {
      var row = 1;
      var column = 1;
      var tiles = [];

      for (var i = 1; i <= 56; i += 1) {
        // const tileHealth = this.randomizeHealth();
        tiles.push({
          id: i,
          position: { row: row, column: column },
          alive: true,
          health: 0,
          score: 0,
          multiplier: 0
        });

        column += 1;

        if (column > this.columns) {
          row += 1;
          column = 1;
        }
      }
      this.setAllAsAlive(tiles, 1);
      return tiles;
      // return this.setAtleastOneMultiplier(tiles, this.level);
    }
  }, {
    key: "setAllAsAlive",
    value: function setAllAsAlive(tiles, level) {
      var _this2 = this;

      this.level = level;

      new Promise(function (resolve) {
        var totalHealth = 200 + level * 15;

        for (var i = 0; i < tiles.length; i += 1) {
          tiles[i].health = 0; //eslint-disable-line
        }

        while (totalHealth > 0) {
          for (var _i = 0; _i < tiles.length; _i += 1) {
            var health = ComboGame.randomBetween(1, totalHealth / tiles.length);
            tiles[_i].health += health; //eslint-disable-line
            tiles[_i].score = tiles[_i].health; //eslint-disable-line
            tiles[_i].multiplier = _this2.randomizeMultiplier(tiles[_i].health); //eslint-disable-line
            totalHealth -= health;
          }
        }
        resolve();
      }).then(function () {
        _this2.setAtleastOneMultiplier(tiles, level);
        tiles.forEach(function (tile, index) {
          setTimeout(function () {
            tile.alive = true; //eslint-disable-line
          }, 10 * index);
        });
      });
    }
  }], [{
    key: "randomBetween",
    value: function randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min); //eslint-disable-line
    }
  }]);

  return ComboGame;
}();

exports.default = ComboGame;

/***/ }),
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raven_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raven_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_offline_plugin_runtime__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_offline_plugin_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_offline_plugin_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(34);








__WEBPACK_IMPORTED_MODULE_3_offline_plugin_runtime__["install"]();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
if (true) {
  __WEBPACK_IMPORTED_MODULE_1_raven_js___default.a.config('https://fa045c6589af499f86db6e761ac36491@sentry.io/187474', {
    release: "a57299363d51ea518e2310b6a761b891caecaafd" }).addPlugin(__WEBPACK_IMPORTED_MODULE_2_raven_js_plugins_vue___default.a, __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]).install();
}

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].afterEach(function (to, from) {
  ga('set', 'page', to.path);
  ga('send', 'pageview');
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App___default.a }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage_fallback__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_local_storage_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_local_storage_fallback__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      shouldSetUserName: false,
      playerName: '',
      client: null,
      highscoreRoom: null,
      highscoreNotification: null,
      showNotification: false,
      highscores: [],
      plays: [],
      clients: 0,
      totalGames: 0,
      screenWidth: 0,
      useAnimations: true,
      runningInApp: window.Android !== undefined || window.webkit !== undefined
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.highscore = parseFloat(__WEBPACK_IMPORTED_MODULE_0_local_storage_fallback___default.a.getItem('highscore') || 0);
    this.playerName = __WEBPACK_IMPORTED_MODULE_0_local_storage_fallback___default.a.getItem('playerName') || this.getRandomPlayerName();
    this.useAnimations = (__WEBPACK_IMPORTED_MODULE_0_local_storage_fallback___default.a.getItem('useAnimations') || 'true') === 'true';

    starx.init({ host: 'api.cccombo.com', path: '/nano' }, function () {
      starx.on('onNewUser', _this.onNewUser);
      starx.on("onTotalPlayedGames", _this.onTotalPlayedGames);
      starx.on("onHighScoreList", _this.onHighScoreList);
      starx.on("onGamesPlayedList", _this.onGamesPlayedList);
      starx.on("onNewHighScore", _this.onNewHighScore);
      starx.on("onPlayerCount", _this.onPlayerCount);
      starx.request('world.join', { name: _this.playerName }, _this.join);
    });
  },

  methods: {
    onNewUser: function onNewUser(data) {
      this.displayNotification({ name: data.name, rank: -1, score: -1 });
    },
    onTotalPlayedGames: function onTotalPlayedGames(data) {
      this.totalGames = data;
    },
    onPlayerCount: function onPlayerCount(data) {
      this.clients = data;
    },
    onHighScoreList: function onHighScoreList(data) {
      this.highscores = data;
    },
    onGamesPlayedList: function onGamesPlayedList(data) {
      console.log('onGamesPlayedList', data);
      this.plays = data;
    },
    onNewHighScore: function onNewHighScore(data) {
      console.log('onNewHighScore', data);
      this.displayNotification({ name: data.name.name, rank: data.rank, score: data.score });
    },
    join: function join(data) {
      console.log(data);
      if (data.code === 0) {
        console.log(data);
      }
    },
    savePlayerName: function savePlayerName() {
      this.shouldSetUserName = false;
      __WEBPACK_IMPORTED_MODULE_0_local_storage_fallback___default.a.setItem('playerName', this.playerName);
    },
    fixViewportHeight: function fixViewportHeight() {
      var clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      this.screenWidth = clientWidth;

      var html = document.querySelector('html');
      function onResize() {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (width !== this.screenWidth) {
          html.style.height = window.innerHeight + 'px';
          this.screenWidth = width;
        }
      }
      window.addEventListener('resize', onResize);

      onResize();
    },
    countUpPlayersOnline: function countUpPlayersOnline(value) {
      var _this2 = this;

      for (var i = 0; i < value - this.clients; i += 1) {
        setTimeout(function () {
          _this2.clients += 1;
        }, 20 * i);
      }
    },
    getRandomPlayerName: function getRandomPlayerName() {
      this.shouldSetUserName = true;
      var playerName = 'Player' + (Math.floor(Math.random() * 10000000) + 1);
      __WEBPACK_IMPORTED_MODULE_0_local_storage_fallback___default.a.setItem('playerName', playerName);
      return playerName;
    },
    displayNotification: function displayNotification(notification) {
      var _this3 = this;

      this.highscoreNotification = notification;
      this.showNotification = true;
      setTimeout(function () {
        _this3.showNotification = false;
      }, 3500);
    }
  },
  computed: {
    notification: function notification() {
      return this.highscoreNotification || { name: '', score: 0, rank: -1 };
    }
  },
  watch: {
    $route: function $route(to, from) {
      if (from.path === '/' && to.path === '/game' && this.shouldSetUserName) this.shouldSetUserName = false;
    }
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'changelog',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_combo_logic__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_combo_logic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_combo_logic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tile__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Tile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RetryMenu__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_RetryMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_RetryMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage_fallback__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_local_storage_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_local_storage_fallback__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'game',
  components: { Tile: __WEBPACK_IMPORTED_MODULE_2__components_Tile___default.a, RetryMenu: __WEBPACK_IMPORTED_MODULE_3__components_RetryMenu___default.a },
  props: {
    client: Object,
    highscoreRoom: Object,
    playerName: String,
    useAnimations: Boolean,
    runningInApp: Boolean
  },
  data: function data() {
    return {
      activePowerUp: null,
      newPowerUp: null,
      columns: 7,
      damage: 1,
      clicksLeft: 20,
      score: 0,
      level: 1,
      combo: 0,
      tiles: [],
      hits: 0,
      highscore: 0,
      events: 0,
      speed: 250,
      multiplierMeter: 0,
      clicksPerLevel: 20,
      showStart: true,
      showHighscore: false,
      comboNeededToLevelUp: 200,
      tileColor: 're',
      changePlayerName: false,
      shouldSetUserName: false,
      game: null,
      totalCombo: 0,
      showLevel: false,
      alreadyRewarded: false,
      powerUps: [{
        id: 0,
        key: 'bomb',
        icon: 'fa-bomb',
        name: 'Bomb',
        show: true,
        amount: 0
      }, {
        id: 1,
        key: 'clear_vert',
        icon: 'fa-arrows-alt-v',
        name: 'Remove vertical',
        show: true,
        amount: 0
      }, {
        id: 2,
        key: 'clear_hor',
        icon: 'fa-arrows-alt-h',
        name: 'Remove horizontal',
        show: true,
        amount: 0
      }, {
        id: 3,
        key: 'clear_both',
        icon: 'fa-arrows-alt',
        name: 'Remove up-down',
        show: true,
        amount: 0
      }, {
        id: 4,
        key: 'extra_taps',
        icon: 'fa-hand-pointer',
        name: 'Taps +10',
        show: false,
        amount: 0
      }]
    };
  },
  mounted: function mounted() {
    var _tiles;

    this.tileColor = __WEBPACK_IMPORTED_MODULE_4_local_storage_fallback___default.a.getItem('tileColor') || 're';
    this.game = new __WEBPACK_IMPORTED_MODULE_1_combo_logic___default.a(this.level, this.columns, this.tileColor);
    this.highscore = parseFloat(__WEBPACK_IMPORTED_MODULE_4_local_storage_fallback___default.a.getItem('highscore') || 0);

    var tiles = this.game.newGame(this.level);
    (_tiles = this.tiles).push.apply(_tiles, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tiles));
  },

  methods: {
    longPress: function longPress(tile) {
      if (!tile.alive) return;
      if (tile.health <= this.clicksLeft) {
        this.clicksLeft -= tile.health;
        this.hit(tile, true, true);
      }
    },
    rewardWithPowerUp: function rewardWithPowerUp() {
      var _this = this;

      var index = this.randomBetween(0, this.powerUps.length - 1);
      var powerUp = this.powerUps[index];
      if (powerUp) {
        this.newPowerUp = powerUp;

        if (powerUp.key === 'extra_taps') {
          this.clicksLeft += 10;
        } else {
          powerUp.amount += 1;
        }

        setTimeout(function () {
          _this.newPowerUp = null;
        }, 1200);
      }
    },
    randomBetween: function randomBetween(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    selectPowerUp: function selectPowerUp(powerUp) {
      if (this.activePowerUp && this.activePowerUp.id === powerUp.id) {
        this.activePowerUp = null;
        return;
      }
      this.activePowerUp = powerUp;
    },
    reward: function reward() {
      if (!this.alreadyRewarded) {
        this.clicksLeft += 20;
        this.alreadyRewarded = true;
      }
    },
    findSurrounding: function findSurrounding(position) {
      var _this2 = this;

      var above = this.getTileByPosition({ row: position.row - 1, column: position.column });
      var below = this.getTileByPosition({ row: position.row + 1, column: position.column });
      var left = this.getTileByPosition({ row: position.row, column: position.column - 1 });
      var right = this.getTileByPosition({ row: position.row, column: position.column + 1 });
      if (above) {
        this.hits += 1;
        setTimeout(function () {
          _this2.hit(above, true);
        }, this.speed);
      }
      if (below) {
        this.hits += 1;
        setTimeout(function () {
          _this2.hit(below, true);
        }, this.speed);
      }
      if (left) {
        this.hits += 1;
        setTimeout(function () {
          _this2.hit(left, true);
        }, this.speed);
      }
      if (right) {
        this.hits += 1;
        setTimeout(function () {
          _this2.hit(right, true);
        }, this.speed);
      }
    },
    startChainReaction: function startChainReaction(tile) {
      if (!tile.alive || this.clicksLeft < 1) {
        return;
      }

      if (this.activePowerUp !== null) {
        this.combo = 0;
        if (this.activePowerUp.key === 'bomb') {
          this.activateBomb(tile);
        }
        if (this.activePowerUp.key === 'clear_vert') {
          this.clearVert(tile);
        }
        if (this.activePowerUp.key === 'clear_hor') {
          this.clearHor(tile);
        }
        if (this.activePowerUp.key === 'clear_both') {
          this.clearBoth(tile);
        }
        this.activePowerUp.amount -= 1;
        this.activePowerUp = null;
        return;
      }

      this.clicksLeft -= 1;
      this.events = 0;
      this.hits += 2;
      this.combo = 0;

      this.hit(tile, false);
    },
    activateBomb: function activateBomb(startTile) {
      var above = this.getTileByPosition({ row: startTile.position.row - 1,
        column: startTile.position.column });
      var below = this.getTileByPosition({ row: startTile.position.row + 1,
        column: startTile.position.column });
      var left = this.getTileByPosition({ row: startTile.position.row,
        column: startTile.position.column - 1 });
      var right = this.getTileByPosition({ row: startTile.position.row,
        column: startTile.position.column + 1 });

      var hitValue = Math.floor(startTile.health / 2);
      if (above) {
        this.hit(above, false, false, hitValue);
      }
      if (below) {
        this.hit(below, false, true, hitValue);
      }
      if (left) {
        this.hit(left, false, true, hitValue);
      }
      if (right) {
        this.hit(right, false, true, hitValue);
      }

      this.hit(startTile, false, true);
    },
    clearVert: function clearVert(startTile) {
      var _this3 = this;

      var tiles = this.tiles.filter(function (x) {
        return x.position.column === startTile.position.column && x.alive;
      });
      tiles.forEach(function (tile) {
        return _this3.hit(tile, false, true);
      });
    },
    clearHor: function clearHor(startTile) {
      var _this4 = this;

      var tiles = this.tiles.filter(function (x) {
        return x.position.row === startTile.position.row && x.alive;
      });
      tiles.forEach(function (tile) {
        return _this4.hit(tile, false, true);
      });
    },
    clearBoth: function clearBoth(startTile) {
      var _this5 = this;

      var tiles = this.tiles.filter(function (x) {
        return (x.position.row === startTile.position.row || x.position.column === startTile.position.column) && x.alive;
      });
      tiles.forEach(function (tile) {
        return _this5.hit(tile, false, true);
      });
    },
    hit: function hit(tile, combo, kill, hitValue) {
      if (tile.alive) {
        tile.health -= this.damage;

        if (kill) {
          tile.health = 0;
        }

        if (hitValue) {
          tile.health -= hitValue;
        }

        if (tile.health <= 0) {
          tile.alive = false;
          tile.health = 0;

          this.combo += 1;
          this.events += 1;
          this.score += 1;

          tile.bonusPoint = this.combo;
          this.multiplierMeter += this.combo;


          if (tile.multiplier !== 1) {
            if (tile.multiplier === -1) {
              this.rewardWithPowerUp();
            } else {
              this.damage += tile.multiplier;
            }
          }
          this.findSurrounding(tile.position);
        }
      }
      this.hits -= combo ? 1 : 2;
    },
    reportScore: function reportScore() {
      starx.notify('world.reportscore', { name: this.playerName, score: parseInt(this.score), isFinal: false });
      if (window.webkit) {
        try {
          console.log('sending score to ios app', this.score);
          window.webkit.messageHandlers.scoreHandler.postMessage(this.score);
        } catch (err) {
          console.log('The native context does not exist yet');
        }
      }
    },
    reset: function reset() {
      this.damage = 1;
      this.clicksLeft = this.clicksPerLevel;
      this.score = 0;
      this.level = 1;
      this.multiplierMeter = 0;
      this.combo = 0;
      this.events = 0;
      this.alreadyRewarded = false;
      this.setAllAsAlive();
      ga('send', 'event', 'Game', 'New');
    },
    setAllAsAlive: function setAllAsAlive() {
      this.game.setAllAsAlive(this.tiles, this.level);
    },
    getTileByPosition: function getTileByPosition(position) {
      return this.tiles.find(function (tile) {
        return tile.position.row === position.row && tile.position.column === position.column;
      });
    }
  },
  computed: {
    test: function test() {
      if (this.newPowerUp !== null) return this.newPowerUp;
      return { id: -1, key: '', icon: '', name: '' };
    },
    centerHeader: function centerHeader() {
      return this.showLevel ? 'Level' : 'Best: ' + this.highscore;
    },
    centerValue: function centerValue() {
      return this.showLevel ? this.level : this.score;
    },
    totalHealth: function totalHealth() {
      var health = 0;
      this.tiles.forEach(function (tile) {
        health += tile.health;
      });
      return health;
    },
    allDead: function allDead() {
      return this.tiles.find(function (tile) {
        return tile.alive;
      }) === undefined;
    },
    comboPercentage: function comboPercentage() {
      return Math.round(this.multiplierMeter / (this.comboNeededToLevelUp / 100));
    },
    gameEnded: function gameEnded() {
      return this.clicksLeft <= 0 && this.hits === 0;
    },
    gameOver: function gameOver() {
      return this.clicksLeft <= 0 && this.hits === 0 && !this.allDead;
    }
  },
  watch: {
    totalHealth: function totalHealth(health) {
      var _this6 = this;

      if (health === 0) {
        setTimeout(function () {
          if (_this6.combo > 3) {
            _this6.score += _this6.combo * 2;
          }

          if (_this6.combo >= _this6.tiles.length) {
            _this6.score += 50;
            _this6.rewardWithPowerUp();
          }

          _this6.score += _this6.clicksLeft * 2;
          _this6.level += 1;
          _this6.clicksLeft += _this6.clicksPerLevel;
          _this6.damage = 1;
          _this6.combo = 0;

          _this6.reportScore();

          _this6.setAllAsAlive();
        }, this.speed * 2);
      }
    },
    combo: function combo(_combo) {
      this.totalCombo += _combo;
    },
    multiplierMeter: function multiplierMeter(value) {
      if (value >= this.comboNeededToLevelUp) {
        this.multiplierMeter -= this.comboNeededToLevelUp;
        this.damage += 1;
      }
    },
    hits: function hits(value) {
      if (value === 0 && this.clicksLeft === 0) {
        ga('send', 'event', 'Game', 'Finished', 'Level', this.level);
      }
    },
    score: function score() {
      if (this.score > this.highscore) {
        this.highscore = this.score;
      }
    },
    gameOver: function gameOver(_gameOver) {
      if (_gameOver) {
        var scoreToReport = this.score;
        ga('send', 'event', 'Game', 'Finished', 'Score', scoreToReport);
        starx.notify('world.reportscore', { name: this.playerName, score: parseInt(scoreToReport, 10), isFinal: true });
      }
    },
    highscore: function highscore() {
      __WEBPACK_IMPORTED_MODULE_4_local_storage_fallback___default.a.setItem('highscore', this.highscore);
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'help',
  data: function data() {
    return {};
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_accounting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_accounting__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'highscore',
  props: ['client', 'highscoreRoom', 'playerName', 'highscores', 'plays'],
  filters: {
    format: function format(value) {
      return __WEBPACK_IMPORTED_MODULE_0_accounting___default.a.formatNumber(value);
    }
  },
  data: function data() {
    return {
      view: 'score'
    };
  },

  computed: {
    list: function list() {
      if (this.view === 'score') return this.highscores;
      return this.plays;
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'retryMenu',
  props: {
    score: [String, Number],
    alreadyRewarded: Boolean,
    runningInApp: Boolean
  },
  data: function data() {
    return {};
  },
  created: function created() {
    console.log('this.runningInApp', this.runningInApp, window.Android, window.webkit);
    if (this.runningInApp) {
      window.addEventListener('message', this.doSomeShit);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.runningInApp) {
      window.removeEventListener('message', this.doSomeShit);
    }
  },
  mounted: function mounted() {
    if (!this.runningInApp) {
      (adsbygoogle = window.adsbygoogle || []).push({});
    }
  },

  methods: {
    doSomeShit: function doSomeShit(e) {
      console.log('does message match', e.origin === location.origin, e.origin, location.origin);
      if (e.origin === location.origin) {
        if (e.data === 'rewarded') {
          this.$emit('reward');
        } else {
          this.$emit('retry');
        }
        console.log('get message from server retry meny', e);
      }
    },
    getExtraClicks: function getExtraClicks() {
      if (window.webkit) {
        try {
          window.webkit.messageHandlers.callbackHandler.postMessage('Hello from JavaScript');
        } catch (err) {
          console.log('The native context does not exist yet');
        }
      }

      if (window.Android) {
        try {
          window.Android.getExtraClicks();
        } catch (err) {
          console.log('The native context does not exist yet');
        }
      }
    }
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tile__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Tile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_local_storage_fallback__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'settings',
  components: { Tile: __WEBPACK_IMPORTED_MODULE_0__components_Tile___default.a },
  data: function data() {
    return {
      selectedTileColor: 're',
      playerName: '',
      availableTileColors: ['re'],
      pointsNeededForUnlock: 500
    };
  },

  methods: {
    save: function save() {
      __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.setItem('playerName', this.playerName);
      __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.setItem('tileColor', this.selectedTileColor);
    },
    selectTileColor: function selectTileColor(color) {
      if (color !== 'secret') {
        this.selectedTileColor = color;
        __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.setItem('tileColor', color);
      }
    }
  },
  mounted: function mounted() {
    var highscore = __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.getItem('highscore') || 0;

    this.availableTileColors.push(highscore > 1 * this.pointsNeededForUnlock ? 'pi' : 'secret');
    this.availableTileColors.push(highscore > 2 * this.pointsNeededForUnlock ? 'pu' : 'secret');
    this.availableTileColors.push(highscore > 3 * this.pointsNeededForUnlock ? 'depu' : 'secret');
    this.availableTileColors.push(highscore > 4 * this.pointsNeededForUnlock ? 'in' : 'secret');
    this.availableTileColors.push(highscore > 5 * this.pointsNeededForUnlock ? 'bl' : 'secret');
    this.availableTileColors.push(highscore > 6 * this.pointsNeededForUnlock ? 'libl' : 'secret');
    this.availableTileColors.push(highscore > 7 * this.pointsNeededForUnlock ? 'cy' : 'secret');
    this.availableTileColors.push(highscore > 8 * this.pointsNeededForUnlock ? 'te' : 'secret');
    this.availableTileColors.push(highscore > 9 * this.pointsNeededForUnlock ? 'gr' : 'secret');
    this.availableTileColors.push(highscore > 10 * this.pointsNeededForUnlock ? 'ligr' : 'secret');
    this.availableTileColors.push(highscore > 11 * this.pointsNeededForUnlock ? 'li' : 'secret');
    this.availableTileColors.push(highscore > 12 * this.pointsNeededForUnlock ? 'ye' : 'secret');
    this.availableTileColors.push(highscore > 13 * this.pointsNeededForUnlock ? 'am' : 'secret');
    this.availableTileColors.push(highscore > 14 * this.pointsNeededForUnlock ? 'or' : 'secret');
    this.availableTileColors.push(highscore > 15 * this.pointsNeededForUnlock ? 'deor' : 'secret');
    this.availableTileColors.push(highscore > 16 * this.pointsNeededForUnlock ? 'br' : 'secret');
    this.availableTileColors.push(highscore > 17 * this.pointsNeededForUnlock ? 'gra' : 'secret');
    this.availableTileColors.push(highscore > 18 * this.pointsNeededForUnlock ? 'blgr' : 'secret');
    this.availableTileColors.push(highscore > 20 * this.pointsNeededForUnlock ? 'wh' : 'secret');

    this.playerName = __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.getItem('playerName');
    this.availableTileColors.push(highscore > 21 * this.pointsNeededForUnlock || this.playerName.indexOf('Jack renlund') > -1 ? 'mc' : 'secret');

    this.selectedTileColor = __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.getItem('tileColor') || 're';
  },

  watch: {
    playerName: function playerName() {
      __WEBPACK_IMPORTED_MODULE_1_local_storage_fallback___default.a.setItem('playerName', this.playerName);
    }
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'start',
  props: {
    clients: [String, Number],
    totalGames: [String, Number],
    runningInApp: Boolean,
    shouldSetUserName: Boolean
  },
  mounted: function mounted() {
    if (!this.runningInApp) {
      if (adsbygoogle) {
        (adsbygoogle = window.adsbygoogle || []).push({});
      }
    }
  },
  data: function data() {
    return {
      gameVersion: '' + "1.4.4-137-ga572993" };
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tile',
  props: ['tile', 'color', 'damage', 'bonusPoint'],
  methods: {},
  computed: {
    tileClass: function tileClass() {
      var classes = [this.color];

      if (this.tile.health <= parseFloat(this.damage)) classes.push('dying');

      if (!this.tile.alive) classes.push('dead');

      return classes;
    }
  }
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 82 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(80)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(107),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(85)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(112),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(87)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(114),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(113),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(79)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(106),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(84)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(111),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(82)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(109),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "menu"
  }, [_vm._v("\n    Oh noes! You're out of taps.\n    "), _c('h1', [_vm._v(_vm._s(_vm.score))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$emit('retry')
      }
    }
  }, [_vm._v("Try again")]), _vm._v(" "), (_vm.runningInApp && !_vm.alreadyRewarded) ? _c('button', {
    on: {
      "click": _vm.getExtraClicks
    }
  }, [_c('i', {
    staticClass: "fa fa-film",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Get extra taps!")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "button blue",
    attrs: {
      "to": {
        'name': 'start'
      },
      "replace": ""
    }
  }, [_vm._v("Main menu")]), _vm._v(" "), _c('div', {
    staticClass: "ads"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-ad-client": "ca-pub-9072364747594224",
      "data-ad-slot": "3124355986",
      "data-ad-format": "auto"
    }
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "changelog"
  }, [_c('h2', [_vm._v("Changelog")]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, [_c('strong', [_vm._v("Version 1.4")]), _vm._v(" "), _c('p', [_vm._v("You can press your score to toggle between current level and score")]), _vm._v(" "), _c('p', [_vm._v("See who the most adicted player is, check the highscore")])])])
}]}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile"
  }, [_c('button', {
    staticClass: "inner",
    class: _vm.tileClass,
    on: {
      "click": function($event) {
        _vm.$emit('hitClick', _vm.tile)
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.tile.health) + "\n    "), _c('div', {
    staticClass: "multiplier",
    class: {
      'show': _vm.tile.multiplier > 1
    }
  }, [_vm._v("+" + _vm._s(_vm.tile.multiplier))]), _vm._v(" "), _c('div', {
    staticClass: "multiplier power-up-icon",
    class: {
      'show': _vm.tile.multiplier === -1
    }
  }, [_c('i', {
    staticClass: "fas fa-dice"
  })]), _vm._v(" "), _c('div', {
    staticClass: "multiplier-bonus",
    class: {
      'show': _vm.tile.health <= 0
    }
  }, [_vm._v(_vm._s(_vm.tile.bonusPoint))])])])
},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-menu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "game",
      "runningInApp": _vm.runningInApp
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('closeChangeName')
      }
    }
  }, [_vm._v("Play")]), _vm._v(" "), _c('div', {
    staticClass: "toolbar"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.changePlayerName = true
      }
    }
  })])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'help'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'highscore'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trophy",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showHighscore = true
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "status-bar"
  }, [_c('div', {
    staticClass: "players-online"
  }, [_vm._v("\n      " + _vm._s(_vm.clients) + "\n      "), _c('p', [_vm._v("Players online")])]), _vm._v(" "), _c('div', {
    staticClass: "games-played"
  }, [_vm._v("\n      " + _vm._s(_vm.totalGames) + "\n      "), _c('p', [_vm._v("Games played")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "game-version"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'changelog'
      }
    }
  }, [_vm._v(_vm._s(_vm.gameVersion))])], 1), _vm._v(" "), _vm._m(2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('div', [_c('span', [_vm._v("c")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("c")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("c")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("o")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("m")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("b")])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("o")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://www.facebook.com/cccombogame/",
      "data-layout": "button_count",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ads"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-ad-client": "ca-pub-9072364747594224",
      "data-ad-slot": "3124355986",
      "data-ad-format": "auto"
    }
  })])
}]}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "client": _vm.client,
      "useAnimations": _vm.useAnimations,
      "clients": _vm.clients,
      "totalGames": _vm.totalGames,
      "runningInApp": _vm.runningInApp,
      "highscoreRoom": _vm.highscoreRoom,
      "playerName": _vm.playerName,
      "highscores": _vm.highscores,
      "plays": _vm.plays
    },
    on: {
      "closeChangeName": function($event) {
        _vm.shouldSetUserName = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "change-player-name",
    class: {
      'show': _vm.shouldSetUserName
    }
  }, [_vm._v("\n    Enter new name\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playerName),
      expression: "playerName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "playerName"
    },
    domProps: {
      "value": (_vm.playerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playerName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.savePlayerName
    }
  }, [_vm._v("Save")])]), _vm._v(" "), _c('div', {
    staticClass: "highscore-notification",
    class: {
      'show': _vm.showNotification
    }
  }, [(_vm.notification.rank > -1) ? [_c('div', {
    staticClass: "highscore-rank"
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-trophy",
    class: {
      'gold': _vm.notification.rank === 1, 'silver': _vm.notification.rank === 2, 'bronze': _vm.notification.rank === 3
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.showHighscore = true
      }
    }
  }), _vm._v(" " + _vm._s(_vm.notification.rank) + ".\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "highscore-name"
  }, [_vm._v("\n        " + _vm._s(_vm.notification.name) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "highscore-score"
  }, [_vm._v("\n        " + _vm._s(_vm.notification.score) + "\n      ")])] : _vm._e(), _vm._v(" "), (_vm.notification.rank === -1) ? [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "new-player-message"
  }, [_vm._v("\n        " + _vm._s(_vm.notification.name) + "\n      ")]), _vm._v(" "), _c('div')] : _vm._e()], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-player-icon"
  }, [_c('div', [_c('i', {
    staticClass: "fas fa-user-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('h2', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "settings-wrapper"
  }, [_c('div', {}, [_c('strong', [_vm._v("Player name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.playerName),
      expression: "playerName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "playerName"
    },
    domProps: {
      "value": (_vm.playerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.playerName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tile-colors"
  }, [_c('strong', [_vm._v("Tile color")]), _vm._v(" "), _c('div', {
    staticClass: "tiles"
  }, _vm._l((_vm.availableTileColors), function(tile) {
    return _c('Tile', {
      key: tile,
      class: {
        'selected': tile === _vm.selectedTileColor
      },
      attrs: {
        "disabled": tile === 'secret',
        "tile": {
          alive: true,
          health: 8
        },
        "color": tile
      },
      nativeOn: {
        "click": function($event) {
          _vm.selectTileColor(tile)
        }
      }
    })
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game",
    class: {
      'animate': _vm.useAnimations
    }
  }, [_c('header', [_c('div', {
    staticClass: "combo"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v("Damage")]), _vm._v("\n        x" + _vm._s(_vm.damage) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "level",
    on: {
      "click": function($event) {
        _vm.showLevel = !_vm.showLevel
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.centerHeader))]), _vm._v("\n      " + _vm._s(_vm.centerValue) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "clicks-left"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', [_vm._v("Taps")]), _vm._v("\n        " + _vm._s(_vm.clicksLeft) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "combo-progress-wrapper"
  }, [_c('div', {
    staticClass: "progress",
    style: ({
      'width': (_vm.comboPercentage + "%")
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "combo-points-progress"
  }, [_vm._v("\n      " + _vm._s(this.multiplierMeter) + " / " + _vm._s(this.comboNeededToLevelUp) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "board"
  }, _vm._l((_vm.tiles), function(tile) {
    return _c('Tile', {
      key: tile.id,
      attrs: {
        "tile": tile,
        "damage": _vm.damage,
        "color": _vm.tileColor
      },
      on: {
        "longPress": _vm.longPress,
        "hitClick": function($event) {
          _vm.startChainReaction(tile)
        }
      }
    })
  })), _vm._v(" "), _c('footer', [_c('p', {
    staticClass: "small-header"
  }, [_vm._v("Power ups")]), _vm._v(" "), _c('div', {
    staticClass: "power-ups"
  }, _vm._l((_vm.powerUps.filter(function (x) { return x.show; })), function(powerup) {
    return _c('div', {
      key: powerup.id,
      staticClass: "power-up-wrapper"
    }, [_c('button', {
      staticClass: "power-up",
      class: {
        'active': _vm.activePowerUp && powerup.id === _vm.activePowerUp.id
      },
      attrs: {
        "disabled": powerup.amount < 1
      },
      on: {
        "click": function($event) {
          _vm.selectPowerUp(powerup)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-fw",
      class: powerup.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(powerup.amount))])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "new-power-up-wrapper",
    class: {
      'show': _vm.test.id > -1
    }
  }, [_c('div', {
    staticClass: "new-power-up"
  }, [_c('h3', {
    staticClass: "new-power-up-name"
  }, [_vm._v("New power up!")]), _vm._v(" "), _c('div', {
    staticClass: "new-power-up-image"
  }, [_c('i', {
    staticClass: "fas fa-fw",
    class: _vm.test.icon
  })]), _vm._v(" "), _c('h3', {
    staticClass: "new-power-up-name"
  }, [_vm._v(_vm._s(_vm.test.name))])])]), _vm._v(" "), (_vm.gameOver) ? _c('RetryMenu', {
    attrs: {
      "score": _vm.score,
      "runningInApp": _vm.runningInApp,
      "alreadyRewarded": _vm.alreadyRewarded
    },
    on: {
      "retry": _vm.reset,
      "reward": _vm.reward
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "highscore"
  }, [_c('h2', [_vm._v("Highscore")]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, _vm._l((_vm.list), function(highscore, index) {
    return _c('div', {
      staticClass: "highscore-row",
      class: {
        'me': highscore[0] === _vm.playerName
      }
    }, [(index >= 3) ? _c('div', {
      staticClass: "number"
    }, [_vm._v(_vm._s(parseFloat(index) + 1) + ".")]) : _vm._e(), _vm._v(" "), (index < 3) ? _c('div', {
      staticClass: "number",
      class: ("trophy" + index)
    }, [_c('i', {
      staticClass: "fa fa-trophy"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(highscore.name.name))]), _vm._v(" "), _c('div', {
      staticClass: "score"
    }, [_vm._v(_vm._s(_vm._f("format")(highscore.score)))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "menu-bar"
  }, [_c('span', {
    class: {
      'active': _vm.view === 'score'
    },
    on: {
      "click": function($event) {
        _vm.view = 'score'
      }
    }
  }, [_vm._v("Highest score")]), _vm._v(" "), _c('span', {
    class: {
      'active': _vm.view === 'played'
    },
    on: {
      "click": function($event) {
        _vm.view = 'played'
      }
    }
  }, [_vm._v("Most played")])])])
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "help"
  }, [_c('h2', [_vm._v("Help")]), _vm._v(" "), _c('div', {
    staticClass: "scores"
  }, [_c('strong', [_vm._v("Power ups")]), _vm._v(" "), _c('p', [_vm._v("\n      On every 7th level or getting a c-c-combo (clearing the field with one combo) will reward you with one random power up\n      "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "power-up-list"
  }, [_c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-bomb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Bomb")]), _vm._v(" "), _c('p', [_vm._v("Kill one tile and hurt the ones around it.")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt-v"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Remove vertical")]), _vm._v(" "), _c('p', [_vm._v("Remove a vertical line")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt-h"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Remove horizontal")]), _vm._v(" "), _c('p', [_vm._v("Remove a horizontal line")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Remove up-down")]), _vm._v(" "), _c('p', [_vm._v("Remove horizontal and vertical line")])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-hand-pointer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('strong', [_vm._v("Taps +10'")]), _vm._v(" "), _c('p', [_vm._v("Get 10 extra taps")])])])])])]), _vm._v(" "), _c('strong', [_vm._v("Combos")]), _vm._v(" "), _c('p', [_vm._v("Bigger combos equals bigger score and bigger bonuses")]), _vm._v(" "), _c('strong', [_vm._v("Combo progress")]), _vm._v(" "), _c('p', [_vm._v("A full combo progress will add one point to your tap damage. Your progress is\n      "), _c('strong', [_vm._v("not")]), _vm._v(" reset after each level. ")])])])
}]}

/***/ })
]),[41]);


// WEBPACK FOOTER //
// static/js/app.cd9828775ed6a2dd19a0.js